import { Node } from '@tiptap/core'

/**
 * Node customizado para preservar tags STYLE com CSS
 * Preserva o conteúdo CSS exato sem adicionar tags <p> internas
 */
export const CustomStyleNode = Node.create({
    name: 'customStyle',
    group: 'block',
    atom: true,

    addAttributes() {
        return {
            cssContent: {
                default: '',
                parseHTML: element => element.innerHTML || element.textContent,
                renderHTML: () => ({}),
            },
        }
    },

    parseHTML() {
        return [{
            tag: 'style',
            getAttrs: element => ({
                cssContent: element.innerHTML || element.textContent || '',
            }),
        }];
    },

    renderHTML({ node }) {
        const cssContent = node.attrs.cssContent || '';
        return ['style', {}, cssContent];
    },

    // View personalizada para renderizar o CSS preservado
    addNodeView() {
        return ({ node }) => {
            const dom = document.createElement('style');
            dom.textContent = node.attrs.cssContent || '';

            return {
                dom,
                contentDOM: null, // Não permite edição do conteúdo
            };
        };
    },
});